import React from 'react';
import { useMatch } from 'app/hooks/index';
import StoryOptions from 'stories/options/index';
import { useHistory } from 'react-router-dom';

const CollectionStoryOptions = ({ onClose, currentStoryId }) => {
  const { replace } = useHistory();
  const {
    params: { id, type, storyId },
  } = useMatch();
  return <StoryOptions storyId={currentStoryId || storyId} onClose={onClose ? onClose : () => replace(`/${type}/${id}`)} />;
};

CollectionStoryOptions.propTypes = {};

export default CollectionStoryOptions;
